import React, { memo } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import loadable from '@loadable/component';
import { DEFAULT_CRYPTO } from '../../constants';
import { handleGetSignatureMoonPay } from '../../lib/getSignature';

interface AddressMap {
  BTC: string;
  BCH: string;
  ETH: string;
  SOL: string;
  POL: string;
  BSC: string;
  DOGE: string;
  XRP: string;
  AVAX: string;
  [key: string]: string;
}

interface StytchUser {
  user_id: string;
  emails: Array<{ email: string; email_id: string; verified: boolean }>;
  phone_numbers: Array<{ phone_number: string }>;
  name?: {
    first_name?: string;
    last_name?: string;
  };
}

interface Props {
  crypto?: string;
  amount?: string;
  fiat?: string;
  addresses: AddressMap | null;
  user: StytchUser | null;
}

const MoonPayProvider = loadable(
  () => import('@moonpay/moonpay-react').then(mod => mod.MoonPayProvider),
  { ssr: false },
);
const MoonPayBuyWidget = loadable(
  () => import('@moonpay/moonpay-react').then(mod => mod.MoonPayBuyWidget),
  { ssr: false },
);

const MoonpayWidget = ({
  crypto,
  amount,
  fiat,
  addresses,
  user,
  ...rest
}: Props) => {
  return (
    <MoonPayProvider
      apiKey={process.env.MOONPAY_LOGIN_API_KEY || ''}
      debug={process.env.NODE_ENV === 'development'}
    >
      <MoonPayBuyWidget
        variant="embedded"
        baseCurrencyCode={fiat}
        baseCurrencyAmount={amount}
        defaultCurrencyCode={crypto || DEFAULT_CRYPTO}
        externalCustomerId={user?.user_id}
        email={user?.emails[0].email}
        theme="light"
        colorCode="#0AC18E"
        walletAddresses={JSON.stringify({
          btc: addresses?.BTC,
          bch: addresses?.BCH,
          eth: addresses?.ETH,
          solana: addresses?.SOL,
          matic: addresses?.POL,
          bnb_bsc: addresses?.BSC,
          doge: addresses?.DOGE,
          xrp: addresses?.XRP,
        })}
        onUrlSignatureRequested={handleGetSignatureMoonPay}
        style={{
          height: '640px',
          width: '480px',
          margin: 0,
          outline: 'none',
          border: 'none',
          boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
        }}
        {...rest}
        visible
      />
    </MoonPayProvider>
  );
};

export default memo(MoonpayWidget);
